var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-skeleton-loader',{staticClass:"ma-2",attrs:{"type":"card","width":"180px","height":"212px"}})}
var staticRenderFns = []

export { render, staticRenderFns }